<template>
  <v-form v-model="isValid">
    <div>
      <v-text-field
        label="Amount to pay"
        type="number"
        :rules="[
          (v) => (v > 0 && v <= parseFloat(this.max)) || 'Amount is invalid',
        ]"
        v-model="amountToPay"
      ></v-text-field>
    </div>
    <button
      class="btn btn-primary no-border bill__button"
      @click.prevent="showPayModal"
      type="submit"
      :disabled="!isValid"
    >
      Pay ${{ amountToPay }}
    </button>
    <button class="btn btn-third bill__button" @click.prevent="hideForm">
      Hide details
    </button>
  </v-form>
</template>

<script>
export default {
  name: 'PostPayForm',
  props: ['openPayModal', 'amount', 'max', 'hideBill', 'locID'],
  data() {
    return {
      isValid: false,
      amountToPay: this.amount,
    };
  },
  methods: {
    showPayModal() {
      this.openPayModal(this.amountToPay, this.locID, 'prePay');
    },
    hideForm() {
      this.hideBill();
    },
  },
};
</script>
